import React from 'react'
import { styled } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import StarIcon from './icons/StarIcon'

const Stars = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '0 auto',
  fontSize: '24px',
})

const RateRating = ({ rating, onChange }) => (
  <Stars>
    {[1, 2, 3, 4, 5].map((value) => (
      <StarIcon
        key={value}
        active={rating >= value}
        onClick={() => onChange(value)}
      />
    ))}
  </Stars>
)

RateRating.defaultProps = {
  rating: null,
}

RateRating.propTypes = {
  rating: PropTypes.number,
  onChange: PropTypes.func.isRequired,
}

export default RateRating
